import { List } from 'immutable';

export const selectParameter = (value) => ({
  type: "SELECT_PARAMETER",
  value
})

export const getFilters = () => ({
  type: "GET_FILTERS"
})

export const toggleFilter = (id) => ({
  type: "TOGGLE_FILTER",
  id
})

export const toggleField = (id) => ({
  type: "TOGGLE_FIELD",
  id
})

export const updateSlider = (value, field, field_id, filter_id, brush,active) => ({
  type: "UPDATE_SLIDER",
  value,
  field,
  field_id,
  filter_id,
  brush,
  active
})

export function filterData() {
  return (dispatch, getState) => {
    const state = getState();
    var activeFilters = List(), drawnPolygons = List();//, chosenUnit = '', chosenMatrix = '';
    if("FilterApp" in state) {
      activeFilters = state.FilterApp.get('activeFilters')
      //chosenUnit = state.FilterApp.get('chosenUnit')
      //chosenMatrix = state.FilterApp.get('chosenMatrix')
    }
    if("MapApp" in state) {
      drawnPolygons = state.MapApp.get('drawnPolygons')
    }
    dispatch({type: "FILTER_DATA", activeFilters: activeFilters, drawnPolygons: drawnPolygons }); //, unit: chosenUnit, matrix: chosenMatrix });
  }
}


// WEBPACK FOOTER //
// ./src/actions/filter.js